import { post } from "../../service/api";

const MerchantAuth = async (payload) => {
    try {
        const response = await post(`/merchant/auth`,payload);
        return response;
    } catch (error) {
        console.error('Error merchant auth:', error);
        throw error;
    }
};

export default MerchantAuth;